<template>
  <div class="container">
    <home-title
      title="学习排行榜"
      :icon="require('@/assets/images/home/home_title/icon6.svg')"
      :showMore="false"
    ></home-title>
    <div class="charts_box dfJcsb">
      <div class="left">
        <div class="charts_top_box">
          <div class="charts_top_item first">
            <div class="charts_avatar_box">
              <img
                class="charts_avatar"
                :src="
                  studyRankData[0].member_head &&
                  studyRankData[0].member_head.indexOf('http') != -1
                    ? studyRankData[0].member_head
                    : 'https://img12.yiihuu.com/270X270/upimg/avatar/?auto=cut'
                "
                alt=""
              />
            </div>
            <div class="charts_rank">NO.1</div>

            <p class="charts_name owtts">{{ studyRankData[0].member_name }}</p>
            <p class="charts_school owtts">{{ studyRankData[0].org_name }}</p>
            <p class="charts_time">学习{{ studyRankData[0].duration_date }}</p>
            <div class="charts_btn_box">
              <div class="charts_btn">谁与我争锋</div>
              <div class="charts_btn hover" @click="goStudy">开始学习</div>
            </div>
          </div>
          <div class="charts_top_item second">
            <div class="charts_avatar_box">
              <img
                class="charts_avatar"
                :src="
                  studyRankData[1].member_head &&
                  studyRankData[1].member_head.indexOf('http') != -1
                    ? studyRankData[1].member_head
                    : 'https://img12.yiihuu.com/270X270/upimg/avatar/?auto=cut'
                "
                alt=""
              />
            </div>
            <div class="charts_rank">NO.2</div>

            <p class="charts_name owtts">{{ studyRankData[1].member_name }}</p>
            <p class="charts_school owtts">{{ studyRankData[1].org_name }}</p>
            <p class="charts_time">学习{{ studyRankData[1].duration_date }}</p>
            <div class="charts_btn_box">
              <div class="charts_btn">谁与我一战</div>
              <div class="charts_btn hover" @click="goStudy">开始学习</div>
            </div>
          </div>

          <div class="charts_top_item third">
            <div class="charts_avatar_box">
              <img
                class="charts_avatar"
                :src="
                  studyRankData[2].member_head &&
                  studyRankData[2].member_head.indexOf('http') != -1
                    ? studyRankData[2].member_head
                    : 'https://img12.yiihuu.com/270X270/upimg/avatar/?auto=cut'
                "
                alt=""
              />
            </div>

            <div class="charts_rank">NO.3</div>

            <p class="charts_name owtts">{{ studyRankData[2].member_name }}</p>
            <p class="charts_school owtts">{{ studyRankData[2].org_name }}</p>
            <p class="charts_time">学习{{ studyRankData[2].duration_date }}</p>
            <div class="charts_btn_box">
              <div class="charts_btn">我要挑战他</div>
              <div class="charts_btn hover" @click="goStudy">开始学习</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right_top general">
          <div class="screen">
            <span
              :class="screenType == 1 ? 'active ta3' : 'ta3'"
              @click="getStudyRankFn(1)"
            >
              本周
            </span>
            <span
              :class="screenType == 2 ? 'active ta3' : 'ta3'"
              @click="getStudyRankFn(2)"
            >
              本月
            </span>
          </div>
          <router-link to="/charts" class="more">
            查看更多 <i class="el-icon-arrow-right"></i>
          </router-link>
        </div>
        <ul class="right_bottom general">
          <li v-for="(e, i) in top5" :key="i" class="dfAic">
            <div class="top_num" :class="i < 3 ? 'top3' : ''">
              {{ i + 1 }}
            </div>
            <div class="top_info">
              <img :src="e.member_head" alt="" />
              <span>
                <div class="top_name toh">{{ e.member_name }}</div>
                <div class="top_org toh">{{ e.org_name }}</div>
              </span>
            </div>
            <div class="top_time">
              {{ e.duration_date }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getStudyRank } from "@/api/charts";
export default {
  name: "studyCharts",
  components: { homeTitle },
  data() {
    return {
      studyRankData: [
        {
          member_head: "无",
          member_name: "虚位以待",
          org_name: "暂无",
          duration_date: "暂无时长",
        },
        {
          member_head: "无",
          member_name: "虚位以待",
          org_name: "暂无",
          duration_date: "暂无时长",
        },
        {
          member_head: "无",
          member_name: "虚位以待",
          org_name: "暂无",
          duration_date: "暂无时长",
        },
      ],
      screenType: 1,
      top5: [],
    };
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getStudyRankFn(1);
  },
  methods: {
    getStudyRankFn(val) {
      let data = {};
      this.dateTemp = new Date();
      data = {
        type: val,
      };
      this.screenType = val;
      data.new_rank_type = 1;
      getStudyRank(data).then((res) => {
        let list = res.list;
        this.studyRankData = list;
        if (this.studyRankData.length < 3) {
          switch (this.studyRankData.length) {
            case 0:
              this.studyRankData.push({
                member_head: "无",
                member_name: "虚位以待",
                org_name: "暂无",
                duration_date: "暂无时长",
              });
              this.studyRankData.push({
                member_head: "无",
                member_name: "虚位以待",
                org_name: "暂无",
                duration_date: "暂无时长",
              });
              this.studyRankData.push({
                member_head: "无",
                member_name: "虚位以待",
                org_name: "暂无",
                duration_date: "暂无时长",
              });
              break;
            case 1:
              this.studyRankData.push({
                member_head: "无",
                member_name: "虚位以待",
                org_name: "暂无",
                duration_date: "暂无时长",
              });
              this.studyRankData.push({
                member_head: "无",
                member_name: "虚位以待",
                org_name: "暂无",
                duration_date: "暂无时长",
              });
              break;
            case 2:
              this.studyRankData.push({
                member_head: "无",
                member_name: "虚位以待",
                org_name: "暂无",
                duration_date: "暂无时长",
              });
              break;
          }
        }
        this.top5 = [];
        for (let i = 0; i < list.length; i++) {
          if (i > 4) return;
          list[i].id = i + 1;
          if (!list[i].member_head || list[i].member_head.indexOf("http")) {
            list[i].member_head =
              "https://img12.yiihuu.com/270X270/upimg/avatar/?auto=cut";
          }
          this.top5.push(list[i]);
        }
      });
    },
    goStudy() {
      location.href = "https://lib.yiihuu.com/list/";
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 30px;
  padding-bottom: 50px;
  .charts_box {
    .left {
      width: 938px;
      height: 450px;
      border-radius: 10px;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
      .charts_top_box {
        display: flex;
        height: 100%;
        align-items: flex-end;
        justify-content: space-between;
        background: url("@/assets/images/home/charts_bg.png");
        background-size: 100% 100%;
        padding: 0 45px;
      }
      .charts_top_item {
        display: inline-block;
        width: 256px;
        text-align: center;
        .charts_avatar_box {
          position: relative;
          margin-top: -120px;
          .charts_avatar {
            display: inline-block;
            width: 84px;
            height: 84px;
            border-radius: 50%;
          }
          &::before {
            content: "";
            position: absolute;
            display: block;
            width: 105px;
            height: 117px;
            top: -30px;
            left: 68px;
          }
        }
        .charts_rank {
          position: relative;
          width: 86px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          font-size: 24px;
          color: #fff;
          font-weight: 700;
          border-radius: 16px;
        }
        .charts_name {
          height: 27px;
          font-size: 20px;
          color: #fff;
          font-weight: 700;
          max-width: 240px;
          line-height: 27px;
          margin: 0 auto 6px;
          letter-spacing: 1px;
        }
        .charts_school {
          font-size: 18px;
          color: #fff;
          max-width: 240px;
          line-height: 24px;
          margin: 0 auto;
          letter-spacing: 1px;
        }
        .charts_time {
          font-size: 16px;
          color: #7e0000;
          margin-top: 18px;
          line-height: 21px;
          letter-spacing: 1px;
        }
        .charts_btn_box {
          width: 163px;
          height: 44px;
          margin: 0 auto;
          position: relative;
          &:hover {
            .charts_btn {
              opacity: 0;
            }
            .hover {
              opacity: 1;
            }
          }
          .charts_btn {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 22px;
            font-size: 16px;
            line-height: 44px;
            text-align: center;
            letter-spacing: 1px;
            background: #fff;
            cursor: pointer;
            transition: all 0.4s;
          }
          .hover {
            opacity: 0;
          }
        }
      }

      .charts_top_item.first {
        height: 282px;
        .charts_avatar_box::before {
          background: url("@/assets/images/charts/first.png");
        }
        .charts_rank {
          background: #fb5c5c;
          margin: -11px auto 51px;
        }
        .owtts {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-shadow: 0px 3px 6px #fb5c5c;
        }
        .charts_time {
          margin: 48px 0 20px;
        }
        .charts_btn_box {
          .charts_btn {
            color: #f75353;
          }
          .hover {
            background: #ffeded;
          }
        }
      }
      .charts_top_item.second {
        height: 250px;
        .charts_avatar_box::before {
          background: url("@/assets/images/charts/second.png");
        }
        .charts_rank {
          background: #fc7612;
          margin: -11px auto 49px;
        }
        .owtts {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-shadow: 0px 3px 6px #fc7612;
        }
        .charts_time {
          margin: 33px 0 15px;
        }
        .charts_btn_box {
          .charts_btn {
            color: #fc7612;
          }
          .hover {
            background: #ffe6d3;
          }
        }
      }
      .charts_top_item.third {
        height: 213px;
        .charts_avatar_box::before {
          background: url("@/assets/images/charts/third.png");
        }
        .charts_rank {
          background: #fdab0d;
          margin: -11px auto 40px;
        }
        .owtts {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-shadow: 0px 3px 6px #fdab0d;
        }
        .charts_time {
          margin: 21px 0 10px;
        }
        .charts_btn_box {
          .charts_btn {
            color: #fdab0d;
          }
          .hover {
            background: #fff0d0;
          }
        }
      }
    }
    .right {
      width: 418px;
      .general {
        width: 100%;
        background: rgba(255, 255, 255, 0.39);
        box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
      }
      .right_top {
        height: 54px;
        margin-bottom: 10px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .screen {
          span {
            display: inline-block;
            width: 28px;
            margin-right: 40px;
            font-size: 14px;
            line-height: 21px;
            color: #333;
            cursor: pointer;
            position: relative;
            &::after {
              content: "";
              display: inline-block;
              width: 0%;
              height: 2px;
              background: #22b79e;
              position: absolute;
              bottom: -8px;
              right: 0;
              left: auto;
              transition: 0.3s;
            }
            &:hover {
              color: #25c894;
              &::after {
                width: 100%;
                right: auto;
                left: 0;
              }
            }
          }
          .active {
            color: #25c894;
            &::after {
              content: "";
              display: inline-block;
              width: 100%;
              height: 2px;
              background: #22b79e;
              position: absolute;
              bottom: -8px;
              left: 0;
            }
          }
        }
        .more {
          font-size: 12px;
          line-height: 16px;
          color: #999;
          &:hover {
            i {
              animation: arrowsSlide 0.3s;
            }
          }
        }
      }
      .right_bottom {
        height: 386px;
        padding-top: 10px;
        li {
          width: 100%;
          height: 70px;
          margin-bottom: 4px;
          justify-content: space-between;
          position: relative;
          &::before {
            content: "";
            display: inline-block;
            position: absolute;
            top: -1px;
            left: 0;
            width: 65px;
            height: 49px;
          }
          .top_num {
            font-size: 32px;
            font-weight: bold;
            color: #ccc;
            width: 64px;
            height: 100%;
            line-height: 70px;
            padding-left: 15px;
            z-index: 2;
          }
          .top3 {
            font-size: 32px;
            font-weight: bold;
            color: #ffffff;
            margin-top: -31px;
          }
          .top_info {
            display: flex;
            flex: 1;
            img {
              width: 42px;
              height: 42px;
              margin-right: 8px;
              border: 2px solid #ffffff;
              box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
              border-radius: 50%;
            }
            span {
              div {
                line-height: 21px;
                color: #333;
                max-width: 200px;
              }
            }
            .top_name {
              height: 21px;
              font-size: 14px;
            }
            .top_org {
              font-size: 12px;
            }
          }
          .top_time {
            font-size: 12px;
            line-height: 21px;
            color: #999;
            margin-right: 20px;
          }

          &:nth-child(1) {
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0) 0%,
              #ffd3d3 100%
            );
            &::before {
              background: url("@/assets/images/home/charts_top1.png");
            }
            .top3 {
              text-shadow: 0px 3px 6px #fc5858;
            }
          }
          &:nth-child(2) {
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0) 0%,
              #ffe1d3 100%
            );
            &::before {
              background: url("@/assets/images/home/charts_top2.png");
            }
            .top3 {
              text-shadow: 0px 3px 6px #fc6c00;
            }
          }
          &:nth-child(3) {
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0) 0%,
              #fff3d3 100%
            );
            &::before {
              background: url("@/assets/images/home/charts_top3.png");
            }
            .top3 {
              text-shadow: 0px 3px 6px #ffb200;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .charts_box {
      .left {
        width: 768px;
        .charts_top_box {
          background: url("@/assets/images/home/charts_bg_small.png");
          padding: 0 42px;
          .charts_top_item {
            width: 200px;
            .charts_avatar_box {
              &::before {
                left: 40px;
              }
            }
            .charts_school {
              font-size: 16px;
              max-width: 190px;
            }
          }
        }
      }
      .right {
        width: 312px;
        .right_bottom {
          li {
            .top_info {
              span {
                div {
                  max-width: 100px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
